import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './helpers';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import { uiActions } from './actions';

function onUpdateAvailable() {
  store.dispatch(uiActions.updateAvailable(true));
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker(onUpdateAvailable);



// WEBPACK FOOTER //
// ./src/index.js